import React from "react";
import { IoClose } from "react-icons/io5";
import { RiBankFill, RiShieldUserFill } from "react-icons/ri";
import { SlArrowRight } from "react-icons/sl";
import { GiWallet } from "react-icons/gi";
import { BsArrowLeft } from "react-icons/bs";

const WithdrawCoin = ({
  setOpenWithdraw,
  setOpenWithdrawBank,
  setOpenWithdrawExWallet,
  setOpenWithdrawDeex,
}: any) => {
  return (
    <div className="fixed inset-0  flex font-manrope justify-start items-start pt-16 overflow-auto pb-16 bg-[#E7EBEE] dark:bg-primary_dark dark:bg-opacity-95  backdrop-blur-sm">
      <div
        className={` w-11/12 mds:w-8/12 md:7/12 border dark:border-[#303030] bg-white  rounded-xl mx-auto p-6 dark:bg-[#192025]   lgss:w-2/5 xxl:w-1/3 `}
      >
        <div className="w-full flex justify-start gap-6 items-center">
          <button
            onClick={() => {
              setOpenWithdraw(false);
            }}
          >
            <BsArrowLeft className="text-black dark:text-white text-[20px]" />
          </button>
          <h4 className="text-gray-900 dark:text-gray-100 font-sora font-semibold text-[20px]">
            Withdraw
          </h4>
        </div>
        <div className="w-full mt-8">
          <h4 className="dark:text-gray-400 text-gray-900 font-sora font-semibold text-[14px]">
            Withdraw to:
          </h4>
          <div
            onClick={() => {
              setOpenWithdraw(false);
              setOpenWithdrawBank(true);
            }}
            className="w-full border border-gray-200 dark:border-gray-600 p-4 rounded-xl cursor-pointer flex justify-between mt-4 items-center"
          >
            <div className="flex  items-center gap-3">
              <RiBankFill className="text-secondary_button text-[24px]" />
              <div>
                <h4 className="dark:text-gray-400 text-gray-900 font-medium text-[15px]">
                  Bank account
                </h4>
                <h4 className="dark:text-gray-400 text-gray-500 font-medium text-[13px]">
                  Withdraw crypto to your local bank{" "}
                </h4>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <SlArrowRight className="text-gray-600 dark:text-white text-[15px]" />
            </div>
          </div>
          <div
            onClick={() => {
              setOpenWithdraw(false);
              setOpenWithdrawExWallet(true);
            }}
            className="w-full border border-gray-200 dark:border-gray-600 p-4 rounded-xl cursor-pointer flex justify-between mt-6 items-center"
          >
            <div className="flex  items-center gap-3">
              <GiWallet className="text-secondary_button text-[24px]" />
              <div>
                <h4 className="dark:text-gray-400 text-gray-900 font-medium text-[15px]">
                  External Wallet
                </h4>
                <h4 className="dark:text-gray-400 text-gray-500 font-medium text-[13px]">
                  Send crypto to other wallet
                </h4>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <SlArrowRight className="text-gray-600 dark:text-white text-[15px]" />
            </div>
          </div>
          <div
            onClick={() => {
              setOpenWithdraw(false);
              setOpenWithdrawDeex(true);
            }}
            className="w-full border border-gray-200 dark:border-gray-600 p-4 rounded-xl cursor-pointer flex justify-between mt-6 items-center"
          >
            <div className="flex  items-center gap-3">
              <RiShieldUserFill className="text-secondary_button text-[24px]" />
              <div>
                <h4 className="dark:text-gray-400 text-gray-900 font-medium text-[15px]">
                  Send to DeeX User{" "}
                </h4>
                <h4 className="dark:text-gray-400 text-gray-500 font-medium text-[13px]">
                  Send crypto to other users for free
                </h4>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <SlArrowRight className="text-gray-600 dark:text-white text-[15px]" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WithdrawCoin;
